"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheStore = void 0;
var types_1 = require("./types");
var CacheStore = /** @class */ (function () {
    function CacheStore(storage, logger) {
        this.store = storage;
        this.logger = logger;
    }
    CacheStore.prototype.getConfigKey = function (user) {
        return user.isAnonymous
            ? types_1.StoreKey.AnonymousConfig
            : types_1.StoreKey.IdentifiedConfig;
    };
    CacheStore.prototype.getConfigUserIdKey = function (user) {
        return "".concat(this.getConfigKey(user), ".user_id");
    };
    CacheStore.prototype.getConfigFetchDateKey = function (user) {
        return "".concat(this.getConfigKey(user), ".fetch_date");
    };
    CacheStore.prototype.loadConfigUserId = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            var userIdKey;
            return __generator(this, function (_a) {
                userIdKey = this.getConfigUserIdKey(user);
                return [2 /*return*/, this.store.load(userIdKey)];
            });
        });
    };
    CacheStore.prototype.loadConfigFetchDate = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            var fetchDateKey, fetchDate;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fetchDateKey = this.getConfigFetchDateKey(user);
                        return [4 /*yield*/, this.store.load(fetchDateKey)];
                    case 1:
                        fetchDate = (_a.sent()) || '0';
                        return [2 /*return*/, parseInt(fetchDate, 10)];
                }
            });
        });
    };
    CacheStore.prototype.saveConfig = function (data, user, dateFetched) {
        var _a;
        var configKey = this.getConfigKey(user);
        var fetchDateKey = this.getConfigFetchDateKey(user);
        var userIdKey = this.getConfigUserIdKey(user);
        this.store.save(configKey, data);
        this.store.save(fetchDateKey, dateFetched);
        this.store.save(userIdKey, user.user_id);
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.info('Successfully saved config to local storage');
    };
    CacheStore.prototype.isBucketedUserConfig = function (object) {
        if (!object || typeof object !== 'object')
            return false;
        return ('features' in object &&
            'project' in object &&
            'environment' in object &&
            'featureVariationMap' in object &&
            'variableVariationMap' in object &&
            'variables' in object);
    };
    CacheStore.prototype.loadConfig = function (user, configCacheTTL) {
        var _a, _b, _c, _d;
        if (configCacheTTL === void 0) { configCacheTTL = 604800000; }
        return __awaiter(this, void 0, void 0, function () {
            var userId, cachedFetchDate, isConfigCacheTTLExpired, configKey, config;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0: return [4 /*yield*/, this.loadConfigUserId(user)];
                    case 1:
                        userId = _e.sent();
                        if (user.user_id !== userId) {
                            (_a = this.logger) === null || _a === void 0 ? void 0 : _a.debug("Skipping cached config: no config for user ID ".concat(user.user_id));
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, this.loadConfigFetchDate(user)];
                    case 2:
                        cachedFetchDate = _e.sent();
                        isConfigCacheTTLExpired = Date.now() - cachedFetchDate > configCacheTTL;
                        if (isConfigCacheTTLExpired) {
                            (_b = this.logger) === null || _b === void 0 ? void 0 : _b.debug('Skipping cached config: last fetched date is too old');
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, this.getConfigKey(user)];
                    case 3:
                        configKey = _e.sent();
                        return [4 /*yield*/, this.store.load(configKey)];
                    case 4:
                        config = _e.sent();
                        if (config === null || config === undefined) {
                            (_c = this.logger) === null || _c === void 0 ? void 0 : _c.debug('Skipping cached config: no config found');
                            return [2 /*return*/, null];
                        }
                        if (!this.isBucketedUserConfig(config)) {
                            (_d = this.logger) === null || _d === void 0 ? void 0 : _d.debug("Skipping cached config: invalid config found: ".concat(JSON.stringify(config)));
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, config];
                }
            });
        });
    };
    CacheStore.prototype.saveUser = function (user) {
        var _a;
        if (!user) {
            throw new Error('No user to save');
        }
        this.store.save(types_1.StoreKey.User, user);
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.info('Successfully saved user to local storage');
    };
    CacheStore.prototype.loadUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.store.load(types_1.StoreKey.User)];
            });
        });
    };
    CacheStore.prototype.saveAnonUserId = function (userId) {
        var _a;
        this.store.save(types_1.StoreKey.AnonUserId, userId);
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.info('Successfully saved anonymous user id to local storage');
    };
    CacheStore.prototype.loadAnonUserId = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.store.load(types_1.StoreKey.AnonUserId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CacheStore.prototype.removeAnonUserId = function () {
        this.store.remove(types_1.StoreKey.AnonUserId);
    };
    return CacheStore;
}());
exports.CacheStore = CacheStore;
exports.default = CacheStore;
//# sourceMappingURL=CacheStore.js.map